'use strict'
import api from '../plugins/api'
import moment from 'moment'
let lastCheckedDate = null
let parameters = []

async function updateParams() {
  parameters = []
  if (
    process.env.VUE_APP_FEATURE_STAGE &&
    (parameters.length == 0 ||
      !lastCheckedDate ||
      (lastCheckedDate &&
        moment().diff(moment(lastCheckedDate), 'minutes') > 30))
  ) {
    const urlGet = process.env.VUE_APP_BACKEND_URL
    const paramsResponse = await api.get(
      `${urlGet}/parameters?&control=${process.env.VUE_APP_CONTROL_KEY}`
    )
    parameters = paramsResponse.data.parameters

    lastCheckedDate = moment().toDate()
  }
}
const isFeatureEnabled = async feature => {
  await updateParams()
  const keyFeature = `/${process.env.VUE_APP_FEATURE_STAGE}/${process.env.VUE_APP_FEATURE_FLAG_PREFIX}/${feature}`
  const foundParam = parameters.find(
    x => x.name.toLowerCase() == keyFeature.toLowerCase()
  )
  const res = foundParam && foundParam.value === '1' ? true : false
  return res
}

async function getSubscriptionCoupons() {
  await updateParams()
  const keyCoupons = `/${process.env.VUE_APP_FEATURE_STAGE}/stripe-coupons`
  const couponsValue = parameters.find(
    x => x.name.toLowerCase() == keyCoupons.toLowerCase()
  )
  const arr =
    couponsValue && couponsValue.value ? couponsValue.value.split(',') : []
  return arr
}

export async function getParameters(parameterNames) {
  await updateParams()
  return parameters.filter(x => parameterNames.indexOf(x.name) != -1)
}

export { isFeatureEnabled, getSubscriptionCoupons }
